import React, { useState } from "react";
import "./FailedOrderFilter.css";

const FailedOrderFilter = ({ setQuery }) => {
  const [filterOrder, setFilterOrder] = useState({
    search: "",
    orderDateFrom: "",
    orderDateTo: "",
    createdDateFrom: "",
    createdDateTo: "",
  });

  const handleChange = (e) => {
    setFilterOrder({ ...filterOrder, [e.target.name]: e.target.value });
  };

  const handleFilter = () => {
    setQuery(filterOrder);
  };

  const clearFilter = () => {
    setFilterOrder({
      search: "",
      orderDateFrom: "",
      orderDateTo: "",
      createdDateFrom: "",
      createdDateTo: "",
    });
    setQuery({});
  };

  return (
    <div className="failed-order-filter-container">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleFilter();
        }}
        className="filter-form"
      >
        <div className="filter-content">
          <div className="filter-fields">
            <div className="filter-row">
              <div className="filter-group filter-search-group">
                <label className="filter-label">
                  <i className="fas fa-search"></i>
                  Search
                </label>
                <input
                  className="filter-input filter-search-input"
                  placeholder="Search by panel, India S.No, seller, ASIN, buyer name, mobile no..."
                  onChange={handleChange}
                  onKeyUp={(event) => {
                    if (event.key === "Enter") {
                      handleFilter();
                    }
                  }}
                  value={filterOrder.search}
                  name="search"
                />
              </div>
              <div className="filter-group">
                <button type="submit" className="btn-search">
                  <i className="fas fa-search"></i>
                  Search
                </button>
              </div>
              <div className="filter-group">
                <label className="filter-label">
                  <i className="fas fa-calendar-alt"></i>
                  Order Date From
                </label>
                <input
                  type="date"
                  className="filter-input"
                  value={filterOrder.orderDateFrom}
                  onChange={handleChange}
                  name="orderDateFrom"
                />
              </div>
              <div className="filter-group">
                <label className="filter-label">
                  <i className="fas fa-calendar-alt"></i>
                  Order Date To
                </label>
                <input
                  type="date"
                  className="filter-input"
                  value={filterOrder.orderDateTo}
                  onChange={handleChange}
                  name="orderDateTo"
                />
              </div>
              <div className="filter-group">
                <label className="filter-label">
                  <i className="fas fa-calendar-check"></i>
                  Created Date From
                </label>
                <input
                  type="date"
                  className="filter-input"
                  value={filterOrder.createdDateFrom}
                  onChange={handleChange}
                  name="createdDateFrom"
                />
              </div>
              <div className="filter-group">
                <label className="filter-label">
                  <i className="fas fa-calendar-check"></i>
                  Created Date To
                </label>
                <input
                  type="date"
                  className="filter-input"
                  value={filterOrder.createdDateTo}
                  onChange={handleChange}
                  name="createdDateTo"
                />
              </div>
              <div className="filter-group">
                <button type="button" onClick={clearFilter} className="btn-clear">
                  <i className="fas fa-times"></i>
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default FailedOrderFilter;
